type StatusBadgeProps = {
  status: string;
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const value = status.toUpperCase();

  const styles: Record<string, string> = {
    ACTIVE: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
    INACTIVE: "bg-slate-700/40 text-slate-300 border-slate-600",
    VISITOR: "bg-sky-500/15 text-sky-400 border-sky-500/20",
    MEMBER: "bg-indigo-500/15 text-indigo-400 border-indigo-500/20",
    PENDING: "bg-amber-500/15 text-amber-400 border-amber-500/20",
  };

  return (
    <span
      className={`inline-flex rounded-full border px-3 py-1 text-xs font-semibold ${
        styles[value] ??
        "border-slate-700 bg-slate-800 text-slate-300"
      }`}
    >
      {status}
    </span>
  );
}